import { DEFAULT_THEME, createTheme, mergeMantineTheme } from '@mantine/core'

import colors from './colors'
import * as Components from './components'
import fonts from './fonts'

const theme = createTheme({
  fontFamily: `${fonts.DMSans.style.fontFamily}, ${DEFAULT_THEME.fontFamily}`,
  fontFamilyMonospace: `${fonts.DMMono.style.fontFamily}, ${DEFAULT_THEME.fontFamilyMonospace}`,
  fontSmoothing: true,
  breakpoints: {
    xs: '36em',
    sm: '48em',
    md: '62em',
    lg: '75em',
    xl: '93em',
  },
  spacing: {
    xxs: '0.25rem', // 4px
    xs: '0.5rem', // 8px
    sm: '1rem', // 16px
    md: '1.5rem', // 24px
    lg: '2rem', // 32px
    xl: '2.5rem', // 40px
    xxl: '3rem', // 48px
  },
  defaultRadius: 'xs',
  radius: {
    xxs: '0.125rem', // 2px
    xs: '0.25rem', // 4px
    sm: '0.5rem', // 8px
    md: '1rem', // 16px
    lg: '1.5rem', // 24px
    xl: '2rem', // 32px
    xxl: '3rem', // 48px
  },

  // Colors
  primaryColor: 'shalion-green',
  primaryShade: 5,
  colors,

  /**
   * Let Mantine pick each filled label's colour from its background's luminance
   * instead of always using white.
   *
   * The brand green is light — luminance 0.63 — so a white label on it is 1.55:1,
   * far under the 4.5:1 WCAG AA floor: "Save", "Build 10 slides" and every other
   * filled primary button was pale text on pale green. Above Mantine's 0.3
   * threshold the label becomes near-black (13.6:1); darker backgrounds keep their
   * white label, so a filled blue stays as it was (6.7:1).
   */
  autoContrast: true,

  // Components
  components: {
    Button: Components.Button,
    Checkbox: Components.Checkbox,
    Divider: Components.Divider,
    Drawer: Components.Drawer,
    Fieldset: Components.Fieldset,
    Input: Components.Input,
    InputWrapper: Components.InputWrapper,
    Modal: Components.Modal,
    MultiSelect: Components.MultiSelect,
    Notification: Components.Notification,
    Pagination: Components.Pagination,
    PasswordInput: Components.PasswordInput,
    PasswordInputWrapper: Components.PasswordInputWrapper,
    Popover: Components.Popover,
    Radio: Components.Radio,
    ScrollArea: Components.ScrollArea,
    Select: Components.Select,
    Tabs: Components.Tabs,
    Title: Components.Title,
    Tooltip: Components.Tooltip,
  },
})

export default mergeMantineTheme(DEFAULT_THEME, theme)
